import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import { ButtonBase, Grid } from '@material-ui/core'
import CopilotSettingItem from './CopilotSettingItem'
import CategoryIcons from './icons/CopilotSettings/CategoryIcons'
import AddCopilotSetting from './icons/CopilotSettings/AddCopilotSetting'
import { GuidelineCategories } from 'consts/hiToolsConsts'

const useStyles = makeStyles(theme => ({
  addItemButton: {
    border: '1px solid rgba(219, 227, 244, 1)',
    borderRadius: 16,
    backgroundColor: 'white',
    height: 80,
    width: '160px',
    [theme.breakpoints.up('lg')]: {
      width: '160px'
    },
    [theme.breakpoints.up('xl')]: {
      width: '220px'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  settingGridItem: {
    // Desktop keeps the auto width that wraps to the fixed 160/220px cards.
    // Phones get a 2-up grid — each item half the row, the cards inside expand to fill.
    [theme.breakpoints.down('xs')]: {
      flexBasis: '50%',
      maxWidth: '50%'
    }
  }
}))

const CopilotSettingsList = ({ categories, onOpenPatientBriefEditorClicked = () => {}, analyticsPayload = {} }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const fallbackIcon = CategoryIcons[GuidelineCategories.OtherAppliancesAndGuidelines]

  return (
    <Grid container spacing={1}>
      {Object.values(categories).map(category => {
        const IconComponent = CategoryIcons[category.key] || fallbackIcon

        return (
          <Grid item key={`copilot-setting-${category.key}`} className={classes.settingGridItem}>
            <CopilotSettingItem
              icon={React.createElement(IconComponent)}
              title={t(`pages.patients.patientSidebar.items.copilot.copilotSettings.categories.${category.key}.title`, {
                defaultValue: category.title
              })}
              summary={category.summary}
              onClick={onOpenPatientBriefEditorClicked}
              categoryData={category}
              analyticsPayload={analyticsPayload}
            />
          </Grid>
        )
      })}
      <Grid item className={classes.settingGridItem}>
        <ButtonBase className={classes.addItemButton} onClick={onOpenPatientBriefEditorClicked}>
          <AddCopilotSetting />
        </ButtonBase>
      </Grid>
    </Grid>
  )
}

export default CopilotSettingsList
